import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ConfigProvider, theme } from 'antd';
import App from './App';
import store from './redux/store';
import './styles/main.less';
import './i18next';
import { mainExpressTheme } from './styles/theme';
import { StyleProvider } from '@ant-design/cssinjs';

import 'antd/dist/reset.css';
import getOrCreateDeviceId from './utils/deviceId';

const { defaultAlgorithm } = theme;

getOrCreateDeviceId();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      cacheTime: 0
    }
  }
});
// @ts-ignore
ReactDOM.createRoot(document.getElementById('app')!).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <StyleProvider hashPriority="low">
        <ConfigProvider
          theme={{
            algorithm: defaultAlgorithm,
            hashed: false,
            ...mainExpressTheme
          }}
        >
          <App />
        </ConfigProvider>
      </StyleProvider>
    </QueryClientProvider>
  </Provider>
);
